module.exports = __webpack_public_path__ + "img/choose-up-11_1_text.e25b40d3.png";